import { axios } from '../config/axios';

const endPoint = '/project/candidate';

const getByRollNo = (rollNo) => {
    return axios.get(`${endPoint}/${rollNo}`);
}

const downloadCandidateTemplate = () => {
    return axios.get(`${endPoint}/download-candidate-template`, {
        responseType: 'blob'
    });
}

const getPresentCount = (projectMasterId) => {
    return axios.get(`${endPoint}/present-count/${projectMasterId}`);
}

const downloadAttendanceSheet = (projectMasterId) => {
    return axios.get(`${endPoint}/download-attendance-sheet/${projectMasterId}`, {
        responseType: 'blob'
    });
}

const getListForUpdateTime = async (projectMasterId, examHallId, searchTerm, pageNumber, limit) => {
    return axios.post(`${endPoint}/list-for-update-time`, {
        projectMasterId: projectMasterId,
        examHallId: examHallId ?? 0,
        search: searchTerm,
        page: pageNumber,
        limit: limit
    });
}

const getListForUnlockCandidate = async (projectMasterId, examHallId, searchTerm, pageNumber, limit) => {
    return axios.post(`${endPoint}/list-for-unlock-candidate`, {
        projectMasterId: projectMasterId,
        examHallId: examHallId ?? 0,
        search: searchTerm,
        page: pageNumber,
        limit: limit
    });
}

const getServerSummaryList = async (projectMasterId, serverId, examHallId, pageNumber, limit , status) => {
    return axios.post(`${endPoint}/list-for-server-summary`, {
        projectMasterId: projectMasterId,
        serverId: serverId,
        examHallId: examHallId,
        page: pageNumber,
        limit: limit,
        status: status

    });
}

const getListAllByPage = async (projectMasterId, searchTerm, pageNumber, limit) => {
    return axios.post(`${endPoint}/list-all-by-project-master-with-pagination`, {
        projectMasterId: projectMasterId,
        search: searchTerm,
        page: pageNumber,
        limit: limit
    });
}

const deleteCandidate = async (candidateId) => {
    return axios.delete(`${endPoint}/delete-candidate/${candidateId}`)
}

const clearLoggedInCount = (candidateId) => {
    return axios.post(`${endPoint}/clear-logged-in-count`, {
        candidateId: candidateId,
    });
}

const resumeExam = (projectMasterId, candidateId, password) => {
    return axios.post(`${endPoint}/list-for-server-summary/resume-exam`, {
        projectMasterId: projectMasterId,
        candidateId: candidateId,
        password: password,
    });
}

const changeDisabledStatus = (candidateId, status, reason) => {
    return axios.post(`${endPoint}/change-disabled-status`, {
        candidateId: candidateId,
        isDisabled: status,
        disabledReason: reason,
    });
}

const changeTechnicalIssueOccurredStatus = (candidateId, status) => {
    return axios.post(`${endPoint}/change-technical-issue-occurred-status`, {
        candidateId: candidateId,
        technicalIssueOccurred: status
    });
}

// Function updated to take projectMasterId first
const downloadAuditLogReportByRollNo = (projectMasterId, rollNo) => {
    return axios.get(`${endPoint}/download-audit-log-report/${projectMasterId}/${rollNo}`, {
        responseType: 'blob'
    });
}

// const downloadAuditLogReportByRollNo = (rollNo) => {
//     return axios.get(`${endPoint}/download-audit-log-report/${rollNo}`, {
//         responseType: 'blob'
//     });
// }

const downloadAnswerPaperByRollNos = (body) => {
    return axios.post(`${endPoint}/download-answer-paper`, body, {
        responseType: 'blob'
    });
}

const exportAnswerPaperByRollNos = (body) => {
    return axios.post(`${endPoint}/export-answer-paper`, body);
}

const downloadShortlistCandidateTemplate = () => {
    return axios.get(`${endPoint}/download-shortlist-candidate-template`, {
        responseType: 'blob'
    });
}

const listShortlistedCandidates = (body) => {
    return axios.post(`${endPoint}/list-shortlisted-with-pagination`, body);
}

const updateShortlistedCandidates = (body) => {
    return axios.post(`${endPoint}/update-shortlisted-candidates`, body);
}

const removeShortListedCandidate = (candidateId) => {
    return axios.post(`${endPoint}/remove-shortlisted-candidate/${candidateId}`);
}

const getBiometricVerifiedCandidatesCount = (driveId) => {
    return axios.post(`${endPoint}/biometric-verified-candidates-count`, { driveId });
}

const getCandidateBiometricDetails = (body) => {
    return axios.post(`${endPoint}/candidate-biometric-details`, body);
}

const verifyThumbImpressionById = (candidateId, body) => {
    return axios.post(`${endPoint}/verify-thumb-impression/${candidateId}`, body);
}

export {
    getByRollNo,
    downloadCandidateTemplate,
    getPresentCount,
    downloadAttendanceSheet,
    getListForUpdateTime,
    getListForUnlockCandidate,
    getServerSummaryList,
    getListAllByPage,
    deleteCandidate,
    resumeExam,
    clearLoggedInCount,
    changeDisabledStatus,
    changeTechnicalIssueOccurredStatus,
    downloadAuditLogReportByRollNo,
    downloadAnswerPaperByRollNos,
    exportAnswerPaperByRollNos,
    downloadShortlistCandidateTemplate,
    updateShortlistedCandidates,
    listShortlistedCandidates,
    removeShortListedCandidate,
    getBiometricVerifiedCandidatesCount,
    getCandidateBiometricDetails,
    verifyThumbImpressionById,
}